import React from 'react';

const GeneratorFooter = ({ isDarkMode }) => {
  return (
    <footer className={`fixed bottom-0 left-0 w-full h-16 flex items-center justify-center font-['Exo_2'] text-sm border-t z-40 ${isDarkMode ? 'bg-gray-900/95 backdrop-blur-md text-gray-400 border-gray-700' : 'bg-gray-100/95 backdrop-blur-md text-gray-600 border-gray-200'}`}>
      <div className="glitch-text" data-text="Card Checker Pro © 2024 - Powered by Future Tech">
        <i className="fas fa-code mr-2"></i>
        Card Checker Pro © 2024 - Powered by Future Tech
        <i className="fas fa-bolt ml-2"></i>
      </div>
    </footer>
  );
};

export default GeneratorFooter;